import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=0cc645be&scoped=true"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"
import style0 from "./charge.vue?vue&type=style&index=0&id=0cc645be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc645be",
  null
  
)

export default component.exports